import { Alert, Button } from "react-bootstrap"
import "./ErrorWindow.css"

const getMessage = (message) => {
    if(message === undefined) {
        return "An error occurred..."
    } else return message
}

const ErrorWindow = (props) => {
    const message = getMessage(props.message)
    const continueButton = props.continue ? <Button onClick={props.continue}>Continue</Button> : undefined
    return (<div className="errorWindow">
        <Alert variant="danger">
            <Alert.Heading>Error</Alert.Heading>
            {message}
        </Alert>
        {continueButton}
    </div>)
}

export default ErrorWindow
